<script setup lang="ts">
  import { computed } from 'vue'

  const props = defineProps<{
    type: 'danger' | 'warning' | 'info' | 'success' | 'gray',
  }>()

  const isDanger = computed(() => props.type === 'danger')
  const isWarning = computed(() => props.type === 'warning')
  const isInfo = computed(() => props.type === 'info')
  const isSuccess = computed(() => props.type === 'success')
  const isGray = computed(() => props.type === 'gray')
</script>

<template>
  <div
    class="flex items-center rounded p-2 space-x-2"
    :class="{
      danger: isDanger,
      warning: isWarning,
      info: isInfo,
      success: isSuccess,
      gray: isGray,
    }">
    <span class="flex text-sm">
      <fa-icon
        v-if="isDanger"
        icon="i-fas-triangle-exclamation" />
      <fa-icon
        v-else-if="isWarning"
        icon="i-fas-diamond-exclamation" />
      <fa-icon
        v-else-if="isInfo"
        icon="i-fas-circle-info" />
      <fa-icon
        v-else-if="isSuccess"
        icon="i-fas-circle-check" />
      <fa-icon
        v-else-if="isGray"
        icon="i-fas-circle-check" />
    </span>
    <span class="text-xs font-medium">
      <slot></slot>
    </span>
  </div>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  .danger {
    @apply bg-danger-100 border-l-danger-500 text-danger-500 border-l-4;
  }
  .warning {
    @apply border-l-4 border-l-warning-600 bg-warning-100 text-warning-600;
  }
  .info {
    @apply bg-info-100 border-l-info-600 text-info-600 border-l-4;
  }
  .success {
    @apply bg-success-50 border-l-success-500 text-success-500 border-l-4;
  }
  .gray {
    @apply bg-gray-100 border-l-gray-500 text-gray-500 border-l-4;
  }
</style>
